import { Button, ListItem, ListItemAvatar, Skeleton } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

import { useTranslation } from '@/core'

type UserTradeBoxSkeletonProps = {}

export const UserTradeBoxSkeleton: FC<UserTradeBoxSkeletonProps> = () => {
  const { t } = useTranslation('tradeRequestUserSelect')
  return (
    <ListItem
      divider
      sx={{
        py: 4,
      }}
      disablePadding
      secondaryAction={<Button>{t('choice')}</Button>}
      disableGutters={true}
    >
      <ListItemAvatar sx={{ mr: 2, minWidth: 'auto' }}>
        <Skeleton height={36} width={36} variant="circular" />
      </ListItemAvatar>
      <SkeletonText variant="small" width="25%" />
    </ListItem>
  )
}
